import React from 'react';
import { Zap, TrendingUp, Flame, Star, Award } from 'lucide-react';

const HypeHero = () => {
  return (
    <div className="relative bg-gradient-to-br from-[#0a0a0b] via-[#1a1a1f] to-[#0a0a0b] overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-[#00ff88] rounded-full blur-[100px] opacity-20 animate-pulse" />
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-[#00d9ff] rounded-full blur-[120px] opacity-20 animate-pulse" style={{animationDelay: '1s'}} />
        <div className="absolute top-40 right-20 w-24 h-24 bg-[#cc00ff] rounded-full blur-[80px] opacity-15 animate-pulse" style={{animationDelay: '2s'}} />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-4 py-20">
        <div className="text-center space-y-8">
          {/* Hype Badge */}
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#00ff88] to-[#00d9ff] text-[#0a0a0b] px-6 py-2 rounded-full font-bold uppercase tracking-wider text-sm neon-glow">
            <Flame className="w-4 h-4" />
            <span>The Tech Revolution Starts Here</span>
          </div>

          {/* Main Headline */}
          <h1 
            className="text-7xl md:text-8xl font-black leading-tight"
            style={{fontFamily: 'Space Grotesk, sans-serif'}}
          >
            <div className="text-gradient mb-4">OH TECH</div>
            <div className="text-white">YES!</div>
          </h1>

          {/* Subheadline */}
          <p className="text-2xl md:text-3xl text-[#b4b4b9] max-w-3xl mx-auto font-medium">
            Real reviews. Maximum hype for the tech that actually matters.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <button className="btn-neon px-8 py-4 rounded-xl text-lg flex items-center gap-3 group">
              <Zap className="w-5 h-5 group-hover:rotate-12 transition-transform" />
              <span>Explore The Hype</span>
            </button>
            <button className="px-8 py-4 bg-transparent border-2 border-[#00ff88] text-[#00ff88] rounded-xl font-bold uppercase tracking-wider text-lg hover:bg-[#00ff88] hover:text-[#0a0a0b] transition-all">
              Latest Reviews
            </button>
          </div>

          {/* Stats Bar */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-16">
            <StatCard icon={<TrendingUp />} number="1M+" label="Monthly Readers" />
            <StatCard icon={<Star />} number="500+" label="Products Reviewed" />
            <StatCard icon={<Award />} number="15" label="Expert Reviewers" />
            <StatCard icon={<Flame />} number="100%" label="Real Opinions" />
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#0a0a0b] to-transparent" />
    </div>
  );
};

const StatCard = ({ icon, number, label }) => (
  <div className="bg-[#1a1a1f] border border-[#00ff88]/20 rounded-xl p-6 hover:border-[#00ff88] hover:shadow-[0_0_30px_rgba(0,255,136,0.2)] transition-all group">
    <div className="text-[#00ff88] mb-2 group-hover:scale-110 transition-transform inline-block">
      {React.cloneElement(icon, { className: 'w-8 h-8' })}
    </div>
    <div className="text-3xl font-black text-gradient mb-1" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
      {number}
    </div>
    <div className="text-sm text-[#b4b4b9] uppercase tracking-wide font-semibold">
      {label}
    </div>
  </div>
);

export default HypeHero;
